const e = "Acción agotada por tiempo. Por favor, verifica tu conexión a internet e intenta de nuevo.", a = { 400: "Esta dirección de correo electrónico no está registrada en $t(_company). Por favor, asegúrate de que es correcta o regístrate a continuación.", 404: "$t(responses.login.400)", 500: "$t(responses.default)" }, s = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, o = { 2033: "Sesión creada exitosamente.", 2064: "Sesión actualizada exitosamente." }, t = { 200: "Has creado tu primera sesión exitosamente.", 201: "$t(responses.dashboardSession.200)" }, n = { 2084: "La solicitud de acceso a la sesión ya estaba en estado aprobado", 2088: "Ya has solicitado acceso a esta sesión.", email: { 200: "Personas añadidas" }, domain: { 200: "Grupo añadido" } }, r = { 200: "¡Genial! Te mantendremos informado." }, i = { 404: "$t(responses.default)", 405: "El código de verificación es incorrecto. Por favor, comprueba de nuevo.", 500: "$t(responses.default)" }, c = { 500: "Lo sentimos, algo salió mal. Por favor, intenta de nuevo.", avatar: { 400: "Error al guardar el avatar. Por favor, intenta de nuevo." } }, d = {
  default: "Lo sentimos, algo salió mal. Por favor, intenta de nuevo.",
  timeout: e,
  login: a,
  register: s,
  session: o,
  dashboardSession: t,
  sessionAccess: n,
  subscribe: r,
  verify: i,
  user: c
};
export {
  t as dashboardSession,
  d as default,
  a as login,
  s as register,
  o as session,
  n as sessionAccess,
  r as subscribe,
  e as timeout,
  c as user,
  i as verify
};
